// extracted by mini-css-extract-plugin
export default {"animate":"fadeIn_animate__Q0ll2","fadeIn":"fadeIn_fadeIn__CPwEE"};